import { ResponsivePie } from "@nivo/pie";
import {
  useMediaQuery,
  useTheme,
} from "@mui/material";

const chartTheme = {
  "tooltip": {
    "container": {
        "background": "#333",
        "color": "#fff",
        "fontSize": 12
    },
  }
}

const data = [
  {
    id: "Mobility",
    label: "Mobility",
    value: 195,
    color: "hsl(90, 70%, 50%)"
  },
  {
    id: "Consumption",
    label: "Consumption",
    value: 419,
    color: "hsl(56, 70%, 50%)"
  },
  {
    id: "Household",
    label: "Household",
    value: 407,
    color: "hsl(103, 70%, 50%)"
  },
  {
    id: "Public Services",
    label: "Public Services",
    value: 474,
    color: "hsl(186, 70%, 50%)"
  },
];

const Chart = () => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  return (
    <div style={{height:"350px"}}>
      <ResponsivePie
        data={data}
        theme={chartTheme}
        margin={{ top: 40, right: 50, bottom: 40, left: 50 }}
        innerRadius={0.5}
        padAngle={1.5}
        cornerRadius={3}
        activeOuterRadiusOffset={5}
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#000"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLabelsSkipAngle={10}
        enableArcLinkLabels={isPhone ? false : true}
        arcLabelsTextColor="#000"
        isInteractive={true}
      />
    </div>
  );
};
export default Chart;
